import { render } from "./ButtonCustomerLoginToggle.vue?vue&type=template&id=1b25efc5"
import script from "./ButtonCustomerLoginToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCustomerLoginToggle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ButtonCustomerLoginToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b25efc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b25efc5', __exports__)) {
    api.reload('1b25efc5', __exports__)
  }
  
  module.hot.accept("./ButtonCustomerLoginToggle.vue?vue&type=template&id=1b25efc5", () => {
    api.rerender('1b25efc5', render)
  })

}


export default __exports__